import React from "react";
import Button from "../../atoms/button/button";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

// Styles //
import "./MediaCardLite.scss";

interface MediaCardLiteProps {
    tituloMultimedia: string;
    imagenPrincipal?: {
        title: string;
        description: string;
        gatsbyImageData: {
            images: {
                sources: {
                    srcSet: string;
                    type: string;
                    sizes: string;
                }[];
            };
        };
        fields: {
            file: {
                url: string;
                fileName: string;
                contentType: string;
            };
        }
    } | null;
    tituloBoton: string;
    redireccionBoton: string;
    tematica?: string;
    onClick?: () => void;
    salario?: string;
    parentContentfulId?: string
}

const MediaCardLite = (props: MediaCardLiteProps) => {
    const {
        tituloMultimedia,
        imagenPrincipal,
        tituloBoton,
        tematica,
        salario,
        redireccionBoton,
        onClick,
        parentContentfulId
    } = props;

    //Bloque creado para google tag manager//
    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
    const tituloMultimediaFixed = removeAccents(tituloMultimedia).replace(/\s+/g, "")
    const isBrowser = typeof window !== "undefined";
    const pathName = isBrowser ? window.location.pathname: '';
    const gtmBasedOnPathName = () =>{
        return  parentContentfulId === 'lj1mUH5LzFPutJgMsQlPF' ?
                    `gtm_ver_detalle_vacante_personas_${tituloMultimediaFixed}`
                : parentContentfulId === '4xmhMfg9xZrUM0riQpUWwK' ?
                    `gtm_ver_mas_comunidades_empresas_${tituloMultimediaFixed}`
                : parentContentfulId == null && pathName === '/servicio-de-empleo/' ? 
                    `gtm_ver_mas_te_ofrecemos_general_${tituloMultimediaFixed}`
                :''
    }
    //Fin bloque google tag manager//
    const image = imagenPrincipal ? getImage(imagenPrincipal) : null;
    
    return (
        <div className="m-media-card-lite">
            {image &&
                <div className="m-media-card-lite__image">
                   {image && (
                        <GatsbyImage image={image} alt={imagenPrincipal?.description || 'default description'} aria-hidden="true" />
                    )}
                </div>
            }
            <div className="m-media-card-lite__content">
                {tematica &&
                    <div className="m-media-card-lite__content__category">
                        <span className="category">{tematica}</span>
                    </div>
                }
                <div className="m-media-card-lite__content__description">
                    <h3>{tituloMultimedia}</h3>
                    {salario &&
                        <div className="m-media-card-lite__content__description__salary">
                            <span className="salary-icon">$</span>
                            <span className="salary">{salario}</span>
                        </div>
                    }
                    <Button
                        id ={tituloMultimediaFixed} 
                        onClickAction={onClick}
                        type="link"
                        text={tituloBoton}
                        classname={`m-media-card-lite__content__description__button ${gtmBasedOnPathName()}`}
                        isDisabled={false}
                        href={redireccionBoton}
                    />
                </div>
            </div>
        </div>
    );
};

export default MediaCardLite;
